export default "__VITE_ASSET__DdYhSAVV__"